import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import './index.scss';

ReactDOM.render(
  <BrowserRouter basename='/site'>
    <App/>
  </BrowserRouter>,
  document.getElementById('root') as HTMLElement
);
